import "core-js/modules/es.array.map";

/*
 * Copyright (c) 2018 Wells Fargo. 455 Market St., San Francisco, CA 94105 All rights reserved.
 *
 *This software is the confidential and proprietary information of Wells Fargo
 *bank. ('Confidential Information'). You shall not disclose such Confidential
 *Information and shall use it only in accordance with the terms of the license
 *agreement you entered into with WellsFargo.
 *
 *Author: Thomas Barry
 *
 *Description:
*/
import React from 'react';
import { compose, withProps, withHandlers } from 'recompose';
import withStrings from 'wfui-digital-core/es/withStrings';
import Button from 'wfui-digital-core/es/Button';
import DialogButtonContainer from 'wfui-digital-core/es/DialogButtonContainer';
import defaultButtons from './default-buttons';
var withClickHandlers = withHandlers({
  handleClick: function handleClick(_ref) {
    var onDecline = _ref.onDecline,
        onAccept = _ref.onAccept;
    return function (_ref2) {
      var confirms = _ref2.confirms,
          navigate = _ref2.navigate;
      return function () {
        return confirms || navigate ? onAccept() : onDecline();
      };
    };
  }
});
var withDefaultButtons = withProps(function (_ref3) {
  var strings = _ref3.strings;
  return {
    defaultButtons: defaultButtons(strings)
  };
});

var CustomConfirmationButtons = function CustomConfirmationButtons(_ref4) {
  var buttons = _ref4.buttons,
      defaultButtons = _ref4.defaultButtons,
      handleClick = _ref4.handleClick;
  return /*#__PURE__*/React.createElement(DialogButtonContainer, {
    horizontal: true
  }, (buttons || defaultButtons).map(function (button) {
    return /*#__PURE__*/React.createElement(Button, {
      key: button.label,
      buttonType: button.type,
      onClick: handleClick(button)
    }, button.label);
  }));
};

export default compose(withStrings, withClickHandlers, withDefaultButtons)(CustomConfirmationButtons);